
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleReservation = () => {
    setIsMobileMenuOpen(false);
    const element = document.querySelector('#reservation');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLineContact = () => {
    setIsMobileMenuOpen(false);
    window.open('https://line.me/R/ti/p/@luciall', '_blank');
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <h1 className="text-2xl md:text-3xl font-serif font-bold text-gold">LUCIALL</h1>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/') ? 'text-gold' : 'text-dark-gray hover:text-gold'
              }`}
            >
              ホーム
            </Link>
            <Link
              to="/body-report"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/body-report') ? 'text-gold' : 'text-dark-gray hover:text-gold'
              }`}
            >
              波動測定
            </Link>
            <Link
              to="/revcella"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/revcella') ? 'text-gold' : 'text-dark-gray hover:text-gold'
              }`}
            >
              Revcella
            </Link>
            <Link
              to="/fit-carving"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/fit-carving') ? 'text-gold' : 'text-dark-gray hover:text-gold'
              }`}
            >
              Fit Carving
            </Link>
            <Link
              to="/menu"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/menu') ? 'text-gold' : 'text-dark-gray hover:text-gold'
              }`}
            >
              メニュー・料金
            </Link>
          </nav>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center space-x-4">
            <button
              onClick={handleReservation}
              className="bg-gold text-white px-6 py-2 rounded-full text-sm font-semibold hover:bg-gold/90 transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap"
            >
              予約する
            </button>
            <button
              onClick={handleLineContact}
              className="bg-white text-gold border-2 border-gold px-6 py-2 rounded-full text-sm font-semibold hover:bg-gold hover:text-white transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap flex items-center gap-2"
            >
              <i className="ri-line-fill text-lg"></i>
              LINE相談
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-dark-gray hover:text-gold transition-colors"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
          <nav className="flex flex-col p-4 space-y-4">
            <Link
              to="/"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`text-base font-medium transition-colors ${
                isActive('/') ? 'text-gold' : 'text-dark-gray hover:text-gold'
              }`}
            >
              ホーム
            </Link>
            <Link
              to="/body-report"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`text-base font-medium transition-colors ${
                isActive('/body-report') ? 'text-gold' : 'text-dark-gray hover:text-gold'
              }`}
            >
              波動測定
            </Link>
            <Link
              to="/revcella"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`text-base font-medium transition-colors ${
                isActive('/revcella') ? 'text-gold' : 'text-dark-gray hover:text-gold'
              }`}
            >
              Revcella
            </Link>
            <Link
              to="/fit-carving"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`text-base font-medium transition-colors ${
                isActive('/fit-carving') ? 'text-gold' : 'text-dark-gray hover:text-gold'
              }`}
            >
              Fit Carving
            </Link>
            <Link
              to="/menu"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`text-base font-medium transition-colors ${
                isActive('/menu') ? 'text-gold' : 'text-dark-gray hover:text-gold'
              }`}
            >
              メニュー・料金
            </Link>
            <div className="pt-4 space-y-3 border-t border-gray-200">
              <button
                onClick={handleReservation}
                className="w-full bg-gold text-white px-6 py-3 rounded-full text-base font-semibold hover:bg-gold/90 transition-all duration-300 shadow-md whitespace-nowrap"
              >
                予約する
              </button>
              <button
                onClick={handleLineContact}
                className="w-full bg-white text-gold border-2 border-gold px-6 py-3 rounded-full text-base font-semibold hover:bg-gold hover:text-white transition-all duration-300 shadow-md whitespace-nowrap flex items-center justify-center gap-2"
              >
                <i className="ri-line-fill text-lg"></i>
                LINE相談
              </button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
